<template>
    <el-dialog :title="title" :visible.sync="centerDialogVisible" width="50%" @close="close">
        <el-card class="box-card" shadow="never">
            <ul class="text">
                <li>
                    <span>举报人：{{ rowCont.memberName }}</span>
                </li>
                <li>
                    <span>举报时间：{{ dateFormat(rowCont.reportDate) }}</span>

                </li>
                <li>
                    <span>举报类型：{{ rowCont.reportType == 0 ? "帖子举报" : "评论举报" }}</span>
                </li>
                <li> <span>被举报人：{{ rowCont.reportName }}</span></li>
                <li>
                    <span>举报原因：{{ rowCont.reportContent }}</span>
                </li>


            </ul>
            <div v-if="isReview" style="margin-right: 20px;margin-top: 20px;">
                <span v-if="rowCont.reviewStatus == 2" style="margin-right: 20px;">审核结果</span>

                <el-row v-if="rowCont.reviewStatus != 2" :span="24" style="margin-top: -10px;">
                    <div v-if="rowCont.reviewStatus == 0">审核结果：审核通过</div>
                    <div v-if="rowCont.reviewStatus == 1">审核结果：审核未通过</div>
                    <div v-if="rowCont.reviewStatus == 2">审核结果：待审核</div>
                </el-row>
                <el-select required="true" v-else :disabled="rowCont.reviewStatus != 2"
                    v-model="reviewParams.reviewStatus" placeholder="请选择" @change="handleChange">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div v-else style="margin-top: 10px;">
                <el-row :span="24">
                    <div v-if="rowCont.reviewStatus == 0">审核结果：审核通过</div>
                    <div v-if="rowCont.reviewStatus == 1">审核结果：审核未通过</div>
                    <div v-if="rowCont.reviewStatus == 2">审核结果：待审核</div>
                </el-row>


            </div>
            <el-divider border-color="#dcdcdc" border-style="dashed"></el-divider>
            <div v-if="rowCont.reportType == 0" style="margin-bottom: 10px;font-size: 20px;font-weight: bold;">帖子内容
            </div>
            <div v-else style="margin-bottom: 10px;font-size: 20px;font-weight: bold;">评论内容</div>
            <el-scrollbar style="height: 200px;line-height: 20px;">
                {{ rowCont.content }}
            </el-scrollbar>
            <!-- <div v-if="rowCont.likesCount == 1" style="margin-top: 20px;">
                <span style="font-size: 20px;font-weight: bold;">被举报人信息</span>
                <div class="text_cont">
                    <div class="text_cont2">
                        <ul>
                            <li><span class="text_cont_img">头像</span><span style="font-weight: bold;">发帖人昵称</span></li>
                            <li><span class="text_cont_child">999</span><span>已发布</span></li>
                            <li><span class="text_cont_child">999</span><span>已评论</span></li>
                            <li><span class="text_cont_child">999</span><span>已收藏</span></li>
                            <li><span class="text_cont_child">999</span><span>获赞数</span></li>
                            <li><span class="text_cont_child">999</span><span>被收藏</span></li>
                        </ul>


                    </div>
                </div>

            </div> -->

            <!-- <div v-if="isShow == true" style="margin-right: 20px;margin-top: 20px;">
                <span style="margin-right: 20px;">禁言天数</span>
                <el-select v-model="value1" placeholder="请选择" :disabled="isDisabled">
                    <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
        </el-card>
        <span v-if="isDisabled == false" slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">返 回</el-button>
            <el-button type="primary" :disabled="rowCont.reviewStatus != 2" @click="review()">确 认</el-button>
        </span>
    </el-dialog>
</template>

<script>
import moment from 'moment';
export default {
    name: 'AdminStaticsAuditEdit',
    data() {
        return {
            centerDialogVisible: false,
            options: [{
                value: 0,
                label: '审核通过'
            }, {
                value: 1,
                label: '拒绝通过'
            },
            ],
            value: '',
            options1: [{
                value: '1',
                label: '3天'
            }, {
                value: '2',
                label: '7天'
            }, {
                value: '3',
                label: '15天'
            },],
            value1: '1',
            rowCont: {},
            title: '',
            isDisabled: false,
            isShow: false,
            reviewParams: {
                reviewStatus: '',
                reportType: '',//    POST_REPORT(0, "帖子举报"),    DISCUSS_REPORT(1, "评论举报");
                memberId: '',
                postId: '',
                discussId: '',
                reportId: ''
            },
            tableData: [],
            total: '',
            isReview: true //审核弹框true 查看弹框false
        };
    },

    mounted() {

    },

    methods: {
        review() {
            let reportType = this.rowCont.reportType;
            this.reviewParams['reportType'] = reportType;
            this.reviewParams['memberId'] = this.rowCont.memberId
            this.reviewParams['postId'] = this.rowCont.postId
            this.reviewParams['discussId'] = this.rowCont.discussId
            this.reviewParams['reportId'] = this.rowCont.id

            this.$api.postOrDiscussReview(this.reviewParams).then(res => {
                console.log(res)
                this.loading = false
                this.tableData = res.data.data.content
                this.total = res.data.data.totalElements
                if (res.data.code == 200) {
                    this.$message.success('审核成功')
                    this.centerDialogVisible = false
                    posts()
                }
            })

        },
        dateFormat(date) {
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        },
        // 触发弹框
        showEdit(row, title) {
            this.rowCont = Object.assign({}, row)
            if (title == '审核') {
                this.title = '审核详情'
                this.isDisabled = false
                this.isReview = true;
            } else {
                this.title = '举报详情'
                this.isDisabled = true
                this.isReview = false;
            }
            this.centerDialogVisible = true
        },
        handleChange(val) {
            this.reviewParams.reviewStatus = val;
        },
        close() {
            this.isShow = false
            this.value = ''
        }

    },

};
</script>
<style lang="scss" scoped>
.clearfix {
    display: flex;
}

.text {
    line-height: 40px;

    li {
        width: 60%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
            width: 200px;
            white-space: nowrap;
        }

    }
}

::v-deep .el-dialog {
    height: 76vh;
}

::v-deep .el-dialog__body {
    height: 78%;
    padding: 10px 20px;
}

::v-deep .el-input__inner {
    height: 30px;
}

::v-deep .el-input__suffix {
    right: 5px;
    transition: all .3s;
    display: flex;
    align-items: center;
}

.text_cont {
    height: 200px;
    line-height: 30px;
    border-top: 2px solid #ccc;
    border-bottom: 2px solid #ccc;
    margin-top: 10px;
}

.text_cont2 {
    margin-top: 20px;

    ul {
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 100px;
        border: 1px solid #ccc;

        li {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            line-height: 30px;

            .text_cont_img {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 50px;
                height: 50px;
                border-radius: 50%;
                border: 1px solid #ccc;
            }
        }

        .text_cont_child {
            font-size: 26px;
            font-weight: bold;
        }
    }
}

.dialog-footer {
    display: flex;
    justify-content: center;

    .el-button {
        width: 50%;
    }
}
</style>